import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import AccountInfoTab from "./Tabs/AccountInfoTab";
import ProfileInfoTab from "./Tabs/ProfileInfoTab";
import AppliedHistoryTab from "./Tabs/AppliedHistoryTab";
import WorkHistoryTab from "./Tabs/WorkHistoryTab";
import userApi from "api/userApi";

export interface Props {
  isOpen: boolean;
  item?: any;
  triggerRefresh?: () => void;
  onClose?: () => void;
}

registerLocale("en", en);
registerLocale("ko", ko);

const UserDetail = ({ isOpen, item, triggerRefresh, onClose }: Props) => {
  const { t, i18n } = useTranslation();
  const [activeTab, setActiveTab] = useState("ACCOUNT_INFO");
  const [dataProfile, setDataProfile] = useState<any>(null);
  
  const tabChange = (tab: any) => {
    if (activeTab !== tab) {
      setActiveTab((_prev) => tab);
    }
  };

  const onCloseClick = () => {
    setActiveTab('ACCOUNT_INFO');
    onClose && onClose();
  };

  const handleUpdateSuccess = async () => {
    if(!item?.id) return;

    try {
      const response: any = await userApi.getUser(item?.id);
      if(response?.data) {
        setDataProfile(response?.data)
      }
    }catch(error) {
      console.log(error)
    }
    triggerRefresh && triggerRefresh();
  }

  const isGuest = () => {
    if(dataProfile?.user_device?.login_type === 'GUEST') return true;

    return false;
  }

  useEffect(() => {
    if(item) {
      setDataProfile(item)
    }
  }, [item])

  return (
    <Modal isOpen={isOpen} centered={true} size="xl" scrollable={true}>
      <ModalHeader toggle={onCloseClick}>{t("Detail User")}</ModalHeader>
      <ModalBody className="pt-0">
        <div style={{ minHeight: "calc(100dvh - 200px)" }}>
          <Col lg={12}>
            <Card
              id="ACCOUNT_INFO"
              style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)", borderTop: "unset" }}
            >
              <div
                style={{
                  background: "#f3f6f9",
                  borderTopLeftRadius: "0.6rem",
                  borderTopRightRadius: "0.6rem",
                  position: "sticky",
                  top: "0px",
                  zIndex: 99,
                  borderTop: "1px solid #e9ebec"
                }}
              >
                <div
                  className="d-block"
                  style={{
                    background: "#f3f6f9",
                    borderRadius: "0.6rem",
                    width: "fit-content",
                  }}
                >
                  <Nav
                    tabs
                    className="nav nav-tabs nav-link-none-hover nav-justified"
                  >
                    <NavItem style={{ minWidth: "120px" }}>
                      <NavLink
                        style={{
                          cursor: "pointer",
                          background: `${
                            activeTab === "ACCOUNT_INFO"
                              ? "var(--vz-primary)"
                              : "unset"
                          }`,
                          color: `${
                            activeTab === "ACCOUNT_INFO" ? "white" : "unset"
                          }`,
                          borderTopRightRadius: 0,
                        }}
                        onClick={() => tabChange("ACCOUNT_INFO")}
                      >
                        {t("Account Info")}
                      </NavLink>
                    </NavItem>
                    <NavItem style={{ minWidth: "100px" }}>
                      <NavLink
                        style={{
                          cursor: `${
                            isGuest() ? "default" : "pointer"
                          }`,
                          background: `${
                            activeTab === "PROFILE_INFO"
                              ? "var(--vz-primary)"
                              : "unset"
                          }`,
                          color: `${
                            activeTab === "PROFILE_INFO" ? "white" : (isGuest() ? "gray" : "unset")
                          }`,
                          borderTopLeftRadius: 0,
                          borderTopRightRadius: 0,
                        }}
                        onClick={() => {
                          if(isGuest()) return;

                          tabChange("PROFILE_INFO")
                        }}
                      >
                        {t("Profile Info")}
                      </NavLink>
                    </NavItem>
                    <NavItem style={{ minWidth: "140px" }}>
                      <NavLink
                        style={{
                          cursor: `${
                            isGuest() ? "default" : "pointer"
                          }`,
                          background: `${
                            activeTab === "WORK_HISTORY"
                              ? "var(--vz-primary)"
                              : "unset"
                          }`,
                          color: `${
                            activeTab === "WORK_HISTORY" ? "white" : (isGuest() ? "gray" : "unset")
                          }`,
                          borderTopLeftRadius: 0,
                          borderTopRightRadius: 0,
                        }}
                        onClick={() => {
                          if(isGuest()) return;

                          tabChange("WORK_HISTORY")
                        }}
                      >
                        {t("Work History")}
                      </NavLink>
                    </NavItem>
                    <NavItem style={{ minWidth: "140px" }}>
                      <NavLink
                        style={{
                          cursor: `${
                            isGuest() ? "default" : "pointer"
                          }`,
                          background: `${
                            activeTab === "APPLIED_HISTORY"
                              ? "var(--vz-primary)"
                              : "unset"
                          }`,
                          color: `${
                            (activeTab === "APPLIED_HISTORY") ? "white" : (isGuest() ? "gray" : "unset")
                          }`,
                          borderTopLeftRadius: 0,
                          borderTopRightRadius: 0,
                        }}
                        onClick={() => {
                          if(isGuest()) return;

                          tabChange("APPLIED_HISTORY")
                        }}
                      >
                        {t("Applied History")}
                      </NavLink>
                    </NavItem>
                  </Nav>
                </div>
              </div>
              <TabContent activeTab={activeTab}>
                <TabPane tabId="ACCOUNT_INFO">
                  {activeTab === "ACCOUNT_INFO" && (
                    <AccountInfoTab data={dataProfile} />
                  )}
                </TabPane>
                <TabPane tabId="PROFILE_INFO">
                  {activeTab === "PROFILE_INFO" && (
                    <ProfileInfoTab data={dataProfile} handleUpdateSuccess={handleUpdateSuccess} />
                  )}
                </TabPane>
                <TabPane tabId="WORK_HISTORY">
                  {activeTab === "WORK_HISTORY" && (
                    <WorkHistoryTab data={dataProfile} />
                  )}
                </TabPane>
                <TabPane tabId="APPLIED_HISTORY">
                  {activeTab === "APPLIED_HISTORY" && (
                    <AppliedHistoryTab data={dataProfile}  />
                  )}
                </TabPane>
              </TabContent>
            </Card>
          </Col>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default UserDetail;
